import swiper from "../../../libs/swiper/dist/js/swiper.js"
export default swiper



// WEBPACK FOOTER //
// ./public/assets/js/src/vendor/swiper.js